export const NFT_PIXEL_CANVAS_CONTRACT =
  process.env.REACT_APP_NFT_PIXEL_CANVAS_CONTRACT || '';
